import cButton from '#themes/default/default/components/button/button.js';
import cCopyLine from '#themes/default/default/components/copyLine/copyLine.js';
import cInfoBox from '#themes/default/default/components/infoBox/infoBox.js';
import cInstructionStep from '#themes/default/default/components/instructionStep/instructionStep.js';
import cOfflineContentBox from '#themes/default/default/components/offlineContentBox/offlineContentBox.js';

import template from './boletoInstructions.html';

export default {
	name: 'CBoletoInstructions',
	components: {
		cButton,
		cCopyLine,
		cInfoBox,
		cInstructionStep,
		cOfflineContentBox
	},
	props: {
		customer: {
			type: Object,
			default: () => null
		},
		payment: {
			type: Object,
			default: () => null
		}
	},
	template
};
